import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of, switchMap } from "rxjs";
import { MatSnackBar } from "@angular/material/snack-bar";
import { PCP_LOGGER } from "@pcp/logging";
import { classroomConnectionActions } from "../../public/state/classroom.actions";
import { SHARED_CLASSROOM_NOTIFICATIONS_CONFIG } from "../../public/notification.tokens";

@Injectable()
export class ConnectionFailedNotificationEffects {

    private readonly config = inject(SHARED_CLASSROOM_NOTIFICATIONS_CONFIG);

    private readonly actions$ = inject(Actions);
    private readonly snackbar = inject(MatSnackBar);
    private readonly log = inject(PCP_LOGGER).createScoped('classroom');

    readonly showNotificationOnJoinLessonFailed$ = createEffect(() => this.actions$.pipe(
        ofType(classroomConnectionActions.connectToClassroomFailed),
        switchMap(({ error}) => {
            this.log.error('Connection closed with error', error instanceof Error ? error : undefined, { error });
            this.log.trackEvent('ConnectionClosedWithError', { error });

            if (this.config.showSnackbarOnJoinLessonFailure) {
                return this.snackbar.open("Verbindung wurde unerwartet geschlossen. Der Unterricht wurde beendet.", undefined, {
                    duration: 5000,
                    panelClass: ["snackbar", "error"],
                }).afterOpened();
            } else {
                return of(null);
            }

        }),
    ), { dispatch: false});
}
